'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactEmotion = require('react-emotion');

var _reactEmotion2 = _interopRequireDefault(_reactEmotion);

var _System = require('./System');

var _System2 = _interopRequireDefault(_System);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var create = new _System2.default({
  createComponent: function createComponent(type) {
    return function () {
      return (0, _reactEmotion2.default)(type, {
        shouldForwardProp: function shouldForwardProp(name) {
          return name !== 'ref' && name !== 'theme';
        }
      }).apply(undefined, arguments);
    };
  }
});

exports.default = create;


//////////////////
// WEBPACK FOOTER
// ../node_modules/system-components/dist/emotion.js
// module id = 594
// module chunks = 0